import { Radar, RadarChart, PolarGrid, PolarAngleAxis, ResponsiveContainer } from 'recharts'

interface Props {
  axes: string[]
  values: Record<string, number>
  height?: number
  color?: string
}

export default function RadarChartMini({ axes, values, height = 220, color = '#1a1a1a' }: Props) {
  const data = axes.map((axis) => ({
    axis,
    value: typeof values?.[axis] === 'number' ? Math.max(0, Math.min(100, values[axis])) : 0,
  }))

  return (
    <ResponsiveContainer width="100%" height={height}>
      <RadarChart data={data} cx="50%" cy="50%" outerRadius="78%">
        <PolarGrid stroke="#dcd7cb" strokeOpacity={0.6} />
        <PolarAngleAxis dataKey="axis" tick={{ fill: '#5a5a5a', fontSize: 11 }} />
        <Radar
          dataKey="value"
          stroke={color}
          fill={color}
          fillOpacity={0.16}
          strokeWidth={1.5}
        />
      </RadarChart>
    </ResponsiveContainer>
  )
}
